import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getAdminHoAccounts} from '../../../../actions/ho-accounts';
import PageTitle from '../../../common/page-title';
import {Link} from 'react-router-dom';
import ArrowButton from "../../../common/button-arrow";
import HoAccountSearch from './search';
import HoAccountTable from './table';

class HoAccountsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      pageNumber: 1
    }
  }

  componentWillMount() {
    this.getHoAccounts();
  }

  getHoAccounts(query = "", pageNumber = "") {
    const { dispatch } = this.props;

    dispatch(getAdminHoAccounts(query, pageNumber)).then(() => {
      this.setState({
        pageNumber: pageNumber
      });
    });
  }

  handleChange(event) {
    this.setState({query: event.target.value});
  }

  handleClear() {
    this.setState({
      query: "",
      pageNumber: 1
    });
    this.getHoAccounts();
  }

  handleSearch() {
    this.getHoAccounts(this.state.query);
  }

  handlePageChange = (page, size) => {
    this.setState({pageNumber:  page}, this.afterPageChange);
  };

  afterPageChange = () => {
    const {query, pageNumber} = this.state;
    this.props.dispatch(getAdminHoAccounts(query, pageNumber));
  };

  render() {
    return (
      <div className="container-fluid">
        <PageTitle>HO Accounts</PageTitle>
        <div className="mg-bottom-60 mg-top-10">
          <div className="pull-left">

          <Link to="/admin/ho-accounts/new">
            <ArrowButton color="red"
               className="add-usergroup"
               submit={false}
               arrow={false}
               permissions={{
                 action: 'add',
                 subjectClass: 'HoAccount'
               }}>Add HO Account</ArrowButton>
          </Link>
          </div>
        </div>
        <HoAccountSearch onSearch={(event) => this.handleSearch(event)}
                         onClear={(event) => this.handleClear()}
                         onChange={(event) => this.handleChange(event)}
                         searchValue={this.state.query}/>
        <HoAccountTable hoAccounts={this.props.hoAccounts}
                        paging={this.props.paging}
                        onPageChange={this.handlePageChange}
                        currentPage={this.state.pageNumber}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hoAccounts: state.hoAccounts.hoAccounts,
    paging: state.hoAccounts.paging
  };
};

export default connect(mapStateToProps)(HoAccountsList);



// WEBPACK FOOTER //
// ./src/components/admin/ho-accounts/list/index.jsx